import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { CloudUploadOutlined } from '@mui/icons-material';
import SectionHeader from '../SectionHeader';
import UploadField from '../UploadField';

const DocumentsSection = ({ form, handleFileChange, uploadingFields }) => {
    return (
        <>
            <SectionHeader icon={CloudUploadOutlined} title="Documents" subtitle="Upload all required and optional documents" />
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Profile Photograph"
                        preview={form.photographPreview}
                        fileName={form.photographName}
                        onChange={handleFileChange('photograph', 'photographPreview', 'photographName')}
                        loading={uploadingFields.photograph}
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Aadhar"
                        preview={form.aadharPreview}
                        fileName={form.aadharName}
                        onChange={handleFileChange('aadhar', 'aadharPreview', 'aadharName')}
                        loading={uploadingFields.aadhar}
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="PAN Document"
                        preview={form.poaImagePreview}
                        fileName={form.poaImageName}
                        onChange={handleFileChange('poaImage', 'poaImagePreview', 'poaImageName')}
                        loading={uploadingFields.poaImage}
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Bank Account Details"
                        preview={form.bankDetailsPreview}
                        fileName={form.bankDetailsName}
                        onChange={handleFileChange('bankDetails', 'bankDetailsPreview', 'bankDetailsName')}
                        loading={uploadingFields.bankDetails}
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Offer Letter Signed Copy"
                        preview={form.offerLetterPreview}
                        fileName={form.offerLetterName}
                        onChange={handleFileChange('offerLetter', 'offerLetterPreview', 'offerLetterName')}
                        loading={uploadingFields.offerLetter}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Employment Agreement Signed Copy"
                        preview={form.empAgreementPreview}
                        fileName={form.empAgreementName}
                        onChange={handleFileChange('empAgreement', 'empAgreementPreview', 'empAgreementName')}
                        loading={uploadingFields.empAgreement}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="NDA"
                        preview={form.ndaPreview}
                        fileName={form.ndaName}
                        onChange={handleFileChange('nda', 'ndaPreview', 'ndaName')}
                        loading={uploadingFields.nda}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Proforma"
                        preview={form.proformaPreview}
                        fileName={form.proformaName}
                        onChange={handleFileChange('proforma', 'proformaPreview', 'proformaName')}
                        loading={uploadingFields.proforma}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Educational Certificate"
                        preview={form.eduCertificatePreview}
                        fileName={form.eduCertificateName}
                        onChange={handleFileChange('eduCertificate', 'eduCertificatePreview', 'eduCertificateName')}
                        loading={uploadingFields.eduCertificate}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Experience Letter"
                        preview={form.expLetterPreview}
                        fileName={form.expLetterName}
                        onChange={handleFileChange('expLetter', 'expLetterPreview', 'expLetterName')}
                        loading={uploadingFields.expLetter}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="Salary Slip"
                        preview={form.salarySlipPreview}
                        fileName={form.salarySlipName}
                        onChange={handleFileChange('salarySlip', 'salarySlipPreview', 'salarySlipName')}
                        loading={uploadingFields.salarySlip}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="CV (Curriculum Vitae)"
                        preview={form.cvPreview}
                        fileName={form.cvName}
                        onChange={handleFileChange('cv', 'cvPreview', 'cvName')}
                        loading={uploadingFields.cv}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <UploadField
                        label="CIF"
                        preview={form.cifPreview}
                        fileName={form.cifName}
                        onChange={handleFileChange('cif', 'cifPreview', 'cifName')}
                        loading={uploadingFields.cif}
                    />
                </Grid>
            </Grid>
        </>
    );
};

DocumentsSection.propTypes = {
    form: PropTypes.object.isRequired,
    handleFileChange: PropTypes.func.isRequired,
    uploadingFields: PropTypes.object
};

DocumentsSection.defaultProps = {
    uploadingFields: {}
};

export default DocumentsSection;
